<template>
  <div>
    <div class="chart-container" :class="{'chart-container-spe1':isA}">
      <div class="Hcp-main-header">
        <div class="main-header-left">
          <span>{{$t('dayByday')}}</span>
        </div>
        <div class="main-header-right">
          <button @click="print"><span>{{$t('print')}}</span></button>
          <button class="set" @click="open"><span>{{$t('set')}}</span></button>
          <p>{{$t('period')}}:<span class="time">{{timeRange2}}</span></p>
        </div>
      </div>
      <hr class="small-hr spe-hr">
      <div  >
      <div class="chart-item2" v-for="(day,index) in date" :key="day" :class="{'spe-item2':(index%3!==0)}">
        <div class="date date-spe3"> <span >{{day}}</span></div>
        <div class="eat-label eat-spe3" :class="[isPo||isFr?'eat-spe3-po':'eat-spe3']">
          <p :class="[isPo?'eat-label-spe1-po':isFr?'eat-label-spe1-fo':'eat-label-spe1']" >{{titleText}}</p>
          <p :class="[isPo||isFr?'eat-label-spe2-po':'eat-label-spe2']">{{$t('Breakfast')}}</p>
          <p :class="[isPo?'eat-label-spe3-po':isFr?'eat-label-spe3-fo':isEn?'eat-label-spe3-en':'eat-label-spe3']" >{{$t('Lunch')}}</p>
          <p :class="[isPo||isFr?'eat-label-spe4-po':isEn?'eat-label-spe4-en':'eat-label-spe4']">{{$t('Dinner')}}</p>
        </div>
        <div :id="'sgChart'+index" class="graph" :element-loading-text="loadingText"  v-loading="index===1?loading:false" style="margin-top: 35px;"></div>
        <div class="carb carb-spe2">
          <span>{{$t('carbs')}} (g)</span>
          <div :id="'carb'+index">
            <label v-for="i in carb[index]" :key="i">{{i[1]}}</label>
            <img class="breakfast" v-for="b in autoBreakfast[index]" :key="b" src="/static/legend/automode/早餐.png"/>
            <img class="lunch" v-for="b in autoLunch[index]" :key="b" src="/static/legend/automode/中餐.png"/>
            <img class="dinner" v-for="b in autoDinner[index]" :key="b" src="/static/legend/automode/晚餐.png"/>
            <img class="snack" v-for="b in autoSnack[index]" :key="b" src="/static/legend/automode/零食.png"/>
          </div>
        </div>
        <div :id="'baChart'+index" class="graph"  element-loading-background="rgba(0, 0, 0, 0.8)"></div>
      </div>
      </div>
    </div>
    <hr class="small-hr">
    <div class="legend-group" :class="{'zh5':!isEn,'it5':isIt,'po5':isPo,'du5':isDu||isFr||isCz}">
      <div class="legend"><img src="../../assets/Hcp-icon/legend/Alert.png"><span>{{$t('alert')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/target.png"><span>{{$t('target')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/hypo.png" class="img-spe"><span>{{$t('hypo')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/SG.png" class="img-spe"><span>{{$t('sensorGlucose')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/calib.png"><span>{{$t('calib')}}</span></div>
      <div class="legend "><img src="../../assets/Hcp-icon/legend/transmitter.png"><span>{{$t('newSen')}}</span></div>
      <div class="legend legend-spe1"><img src="../../assets/Hcp-icon/legend/warm up.png"><span>{{$t('warm')}}</span></div>
      <div class="legend legend-spe1" :class="{'zh6':!isEn}"><img src="../../assets/Hcp-icon/legend/basal.png"><span>{{$t('basal')}}</span></div>
      <div class="legend legend-spe1" :class="{'zh7':!isEn}"><img src="../../assets/Hcp-icon/legend/temp basal.png"><span>{{$t('tampBasal')}}</span></div>
      <div class="legend legend-spe3" :class="{'zh8':!isEn}"><img src="../../assets/Hcp-icon/legend/normal bolus.png"><span>{{$t('normalBolus')}}</span></div>
      <div class="legend legend-spe4" :class="{'zh9':!isEn}"><img src="../../assets/Hcp-icon/legend/extend bolus.png"><span>{{$t('extendBolus')}}</span></div>
      <div class="legend legend-spe5" :class="{'zh10':!isEn}"><img src="../../assets/Hcp-icon/legend/auto suspend.png"><span class="span1">{{$t('manualStop')}}</span></div>
      <div class="legend legend-spe1" :class="{'zh11':!isEn}"><img src="../../assets/Hcp-icon/legend/Auto Suspend 2.png"><span class="span1">{{$t('autoStop')}}</span></div>
      <div class="legend legend-spe1"><img src="../../assets/Hcp-icon/legend/patch Deactivated.png"><span>{{$t('stop')}}</span></div>
      <div class="legend legend-spe6" :class="{'zh12':!isEn}"><img src="../../assets/Hcp-icon/legend/new Patch.png"> <span>{{$t('newPatch')}}</span></div>
      <div class="legend legend-spe7" :class="{'zh13':!isEn}" ><img src="../../assets/Hcp-icon/legend/carbs.png"><span>{{$t('carbs')}}</span></div>
      <div class="legend legend-spe2" :class="{'zh14':!isEn}"><img src="../../assets/Hcp-icon/legend/exercise.png"><span>{{$t('exercise')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/calibrate_1.png"><span>{{$t('BG Reading')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/早餐.png"><span>{{$t('Breakfast')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/中餐.png"><span>{{$t('Lunch')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/晚餐.png"><span>{{$t('Dinner')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/零食.png"><span>{{$t('t1222_Snack')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/icon_histogram.png"><span>{{$t('t1222_auto_basal')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/auto_bolus.png"><span>{{$t('t1222_auto_bolus')}}</span></div>
    </div>

    <!--Add对话框-->
    <el-dialog  :visible.sync="typeChooseVisible" :size=dialogSize  id="dialog-form2" :show-close="false" >
      <div slot="title" class="patientList-dialog-title">
        <span>{{$t('setPeriod')}}</span>
        <img src="../../assets/cancel.png" @click="cancel">
      </div>
      <div slot class="dialog-body">
        <div class="duration" >
          <span>{{$t('duration')}}</span>
          <select id="duration" @change="procTimeRangeSelect" v-model="timeType">
            <!--<option value=1 :selected="Select">{{$t('7 days')}}</option>
            <option value=2 :selected="!Select">{{$t('14 days')}}</option>-->
            <option value=1>{{$t('7 days')}}</option>
            <option value=2>{{$t('14 days')}}</option>
          </select>
        </div>
        <div class="time-range" :class="{'zh2':!isEn}">
          <p>{{$t('From')}}</p>
          <div class="date">
            <span>{{staTime}}</span>
          </div>
          <p>{{$t('To')}}</p>
          <div class="block">
            <el-date-picker v-model="value3" type="date"  :editable=false  :picker-options="pickerOptions"
                      :clearable=false  :placeholder="endTime"  @change="procTimeRangeSelect"   format="dd-MM-yyyy">
            </el-date-picker>
          </div>
        </div>
        <hr class="patientList-small-hr">
      </div>
      <div slot="footer" class="dialog-footer">
        <button @click="dateApply">{{$t('applyM')}}</button>
        <button  class="cancelButton" @click="cancel">{{$t('Cancel')}}</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  import {loading} from '../mixins/loading'
  import format from '@/lib/format'
  import formatClass from '@/lib/chartTipFormat';
  /*
  Notes:
  2019-8-6

  * */
  export default {
    mixins: [loading],
    data() {
      return {
        pump_device:'--',
        isA:false,value2:'',value3:'', uid:0, st:0,et:0,  sg:[], basal:[],bolus:[],timeSection:[],staTime:'',endTime:'',timeRange2:'',isMg:'',Select:'',
        mealTime1:[[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10]],
        mealTime2:[[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10]],
        mealTime3:[[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10],[10,10,10]], NewBasal:[],isEn:false,ts:[],trans:[],isIt:false,isPo:false,
        sensor_alarm:[], pump_alarm:[],carb:[],exercise:[],calib:[],bg:[],basalMax:5,bolusMax:5,timeType:"",isDu:false,isFr:false,isCz:false,
        extend_bolus:[[10,10,10,10,10],[10,10,10,10,10],[10,10,10,10,10],[10,10,10,10,10],[10,10,10,10,10],[10,10,10,10,10],[10,10,10,10,10]],
        basal_suspend:[],stopBasal:[],manualStop:[],tempBasal:[],typeChooseVisible:false,dialogSize:'tiny',
        autoModeBasal:[],
        autoModeCorrBolus:[],
        autoBreakfast:[],
        autoLunch:[],
        autoDinner:[],
        autoSnack:[],
        sgChart0:null, sgChart1:null, sgChart2:null, sgChart3:null, sgChart4:null,
        sgChart5:null, sgChart6:null, sgChart7:null, sgChart8:null, sgChart9:null,
        sgChart10:null, sgChart11:null, sgChart12:null,sgChart13:null,
        baChart0:null, baChart1:null, baChart2:null, baChart3:null, baChart4:null,
        baChart5:null, baChart6:null, baChart7:null, baChart8:null, baChart9:null,
        baChart10:null, baChart11:null, baChart12:null,baChart13:null,
        chart2:null,dayNum:7,
        sgMax:20,
        pickerOptions:{
          disabledDate(time){
            let t1=time.getTime();
            let d2=new Date();
            let t2=d2.getTime();
            //return (t1>t2 || (d2.getYear()-time.getYear())>2 );
            return (t1>t2 || t1<(t2-730*86400*1000));
          }
        },
        pickerOptions2:{
          disabledDate(time){
            let flag1 = time.getTime()>Date.now(),flag2=true;
            return flag1;
          }
        },
        date:['','','','','',''],
        titleText:'SG (mmol/L)',
        textStyle:{
          color:'#282828',
          fontWeight:'normal',
          fontSize:'12',
          fontFamily:'SFUIText-Regular'
        },
        titlePadding:[12,0,0,35],
        grid2:{x:'8%',y:'5%',width:'87%',height:'60%'},
        yAxisLabel:{interval:0,margin:5,textStyle:{color:'#282828',baseline:'middle',},showMinLabel:false},
        yAxisLabel2:{show:false},
      }
    },
    computed: {
      DataD(){
        return this.$store.state.DataD;
      },
      DataSG(){
        return this.$store.state.DataSG;
      },
      DataBasal(){
        return this.$store.state.DataBasal;
      },
      DataBolus(){
        return this.$store.state.DataBolus;
      },
    },
    methods: {
      drawSgChart(id,i) {
        let that = this;
        this[id] = echarts.getInstanceByDom(document.getElementById(id));
        if(this[id]===undefined){
          this[id] = echarts.init(document.getElementById(id));
        }
        this.registLoading(id,this[id])
        this[id].setOption({
          title:{
            // text:this.titleText,
            textStyle:this.textStyle,
            padding:this.titlePadding,
          },
          tooltip:{
            trigger:'item',
            axisPointer:{
              type:'line',
              axis:'x',
              lineStyle:{color:'#333',}
            },
            backgroundColor:'#555',
            textStyle:{
              color: ' #ffffff',
            },
            formatter:function(params){
              let tip = format.formatterTip1(params,that);
              return tip ;
            },
          },
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(this.timeSection[i][0]*1000),
            max:new Date(this.timeSection[i][1]*1000),
            axisLabel: {show:false},
            axisLine: {lineStyle: {color: '#ccc'}},
            interval:3600*3000,
            axisPointer:{
              snap:true,
              show:true,
              type: 'line',
              label:{
                show: false
              },
              lineStyle:{
                color: 'black'
              },
              triggerTooltip:true
              }
          }],
          yAxis: [{
            type:'value',
            min:0,
            max:this.sgMax,
            axisLabel:this.yAxisLabel,
            axisLine:{lineStyle:{color:'#ccc'}},
            boundaryGap:false,
            splitLine:{show:true,},
            axisTick:{length:0},
          }],
          grid:this.grid2,
          animation:false,
          series: [
            // 按照seriesIndex顺序渲染，后面会覆盖前面
            {
              type: 'scatter',
              data: this.bg[i],
              name:'bg',
              symbol:'image://static/legend/calibrate_1.png',
              symbolSize:10,
              tooltip:{backgroundColor:'#555',
              trigger:'item',
                formatter:(params)=>{
                  const timeDetail = formatClass.getFormatterTip1TimeDetail(params.value[0]);
                  const tip = timeDetail + formatClass.bgFormat(params, this);
                  return  tip;
                },
              },
              label:{
                show: this.$store.state.glucose_display==='On',
                color: '#114C9A',
                backgroundColor:'#E7F5F9',
                position: 'top',
                distance:10,
                fontSize:12,
                width:30,
                height:15,
                borderColor:'#7AACBF',
              },
              emphasis: {
                focus: 'self'
              },
            },
            {
              type: 'scatter',
              data: this.calib[i],
              name:'calib',
              symbol:'image://static/legend/calib.png',
              symbolSize:10,
              tooltip:{backgroundColor:'#555',
                formatter:(params)=>{
                  const timeDetail = formatClass.getFormatterTip1TimeDetail(params.value[0]);
                  const tip = timeDetail + formatClass.calibFormat(params, this);
                  return  tip;
                },
              },
              label:{
              show: this.$store.state.glucose_display==='On',
              color: '#114C9A',
              backgroundColor:'#E7F5F9',
              position: 'top',
              distance:10,
              fontSize:12,
              width:30,
              height:15,
              borderColor:'#7AACBF',
              },
              emphasis: {
                focus: 'self'
              },
            },
            {
              type: 'scatter',
              name:'transmtr',
              data: this.trans[i],
              symbol:'rect',
              symbolSize:5,
              itemStyle: {normal: {color: '#00a107'}},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+'New Sensor';
                },
              },
            },
            {
              name:'SG',
              type: 'scatter',
              data: this.sg[i],
              markArea: {
                data: [
                  [{yAxis: (this.isMg)?this.DataD.target_low*18:this.DataD.target_low}, {yAxis:(this.isMg)?this.DataD.target_high*18:this.DataD.target_high}]
                ],
                tooltip:{show:false,
                trigger:'none'},
                itemStyle: {
                  normal: {
                    color: 'rgba(211,255,213,0.6)',
                  }
                }
              },
              markLine: {
                data: [{ yAxis:(this.isMg)?this.DataD.hypo*18:this.DataD.hypo}],
                symbol:['circle','circle'],
                silent:true,
                symbolSize: 1,
                tooltip:{show:false,
                trigger:'none'},
                lineStyle: {normal: {color: 'rgba(255,0,0,0.5)', type: 'solid',}},
                label:{normal:{show:false}},
              },
              itemStyle: {normal: {
                color:function (params) {
                  let color = '#2cd200';
                  if(params.value[1]<0.1&&params.value[2]==='H'){
                    color = '#a4a4a4';
                  }
                  else{
                    if(that.isMg){
                      if(params.value[1]>that.DataD.target_high*18){color = '#e6be00'}
                      if(params.value[1]<that.DataD.target_low*18){color = '#ff5c5c'}
                    }else{
                      if(params.value[1]>that.DataD.target_high){color = '#e6be00'}
                      if(params.value[1]<that.DataD.target_low){color = '#ff5c5c'}
                    }
                  }
                  let type = params.value[2];
                  if((type==='NC'&&params.value[1]==0)||type==='DE'||type==='CE0'||type==='CE1'){
                    color = 'transparent';
                  }
                  return color;
                }
              }},
              symbolSize:2,
              tooltip:{backgroundColor:'#555',
                  formatter:(params)=>{
                    const timeDetail = formatClass.getFormatterTip1TimeDetail(params.value[0]);
                    const tip = timeDetail + formatClass.SGFormat(params, this);
                  return  tip;
                },
              },
            },
            {
              type: 'custom',
              data:this.mealTime1,
              z:-1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              tooltip:{show:false,
              trigger:'none'},
              itemStyle:{normal: {color: 'rgba(170,170,170,0.15)'}},
            },
            {
              type: 'custom',
              data:this.mealTime2,
              z:-1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              tooltip:{show:false,
              trigger:'none'},
              itemStyle:{normal: {color: 'rgba(170,170,170,0.15)'}},
            },
            {
              type: 'custom',
              data:this.mealTime3,
              z:-1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              tooltip:{show:false,
              trigger:'none'},
              itemStyle:{normal: {color: 'rgba(170,170,170,0.15)'}},
            },
          ]
        });
        //console.log('画1图时间:'+ (new Date()-t));
      },
      drawBasalChart(id,i) {
        let that=this;

        this[id] = echarts.init(document.getElementById(id));
        this.registLoading(id,this[id])
        this[id].setOption({
          title:[
            {
              text: this.$t('basal')+' '+this.$t('basal_unit'),
              textStyle:this.textStyle,
              padding:this.titlePadding,
            },{
              text: this.$t('bolus')+' '+this.$t('ins_unit'),
              textStyle: this.textStyle,
              right: '17',
              top:'7',
            },
          ],
          tooltip:{
            trigger:'axis',
            axisPointer:{
              type:'line',
              axis:'x',
              lineStyle:{color:'#333',}
            },
            backgroundColor:'#555',
            textStyle:{
              color: ' #ffffff',
            },
            formatter:function(params){
              let tip = format.formatterTip(params, that, 'chart2');
              return tip ;
            },
          },
          xAxis: [{
            type: 'time',
            boundaryGap: false,
            min:new Date(this.timeSection[i][0]*1000),
            max:new Date(this.timeSection[i][1]*1000),
            axisLabel:{
              showMaxLabel:true,
              interval:0,margin:12,textStyle:{color:'#282828',baseline:'middle'},
              formatter: function(value,index){
                // let H = new Date(value).getHours();
                index=(value-that.timeSection[i][0]*1000)/(3600000*3);   //
                let H=index*3;
                // if(index%8===0&&index!==0){
                //   H = H+24+':00';
                //   return  H;
                // } else {
                //   if(index%2===0){
                //     H = H<10 ? ('0'+H+':00' ): H+':00';
                //     return  H;
                //   }else{
                //     return ' ';
                //   }
                // }
                if(H<24){
                  if(H%3===0){
                    H = H<10 ? ('0'+H+':00' ): H+':00';
                    return  H;
                  }else{
                    return ' ';
                  }
                }else{
                  // console.log('time axis 24H');
                  return '24:00';
                }
              },
            },
            axisLine: {lineStyle: {color: '#ccc'}},
            // interval:3600*3000,
            splitNumber: 8,
          }],
          yAxis: [
            {
              type:'value',
              boundaryGap:false,
              min:0,
              max:this.basalMax,
              splitLine:{show:true,},
              axisTick:{length:0},
              axisLabel:this.yAxisLabel,
              axisLine:{lineStyle:{color:'#ccc'}},
            }, {
              type:'value',
              boundaryGap: false,
              min:0,
              max:this.bolusMax,
              axisTick: {length: 0},
              axisLabel:this.yAxisLabel,
              axisLine: {lineStyle: {color: '#ccc'}},
            }
          ],
          grid:this.grid2,
          animation:false,
          series: [
            {
              type: 'line',
              name:this.$t('basal'),
              data:this.basal[i],
              // step:'middle',
              itemStyle: {normal: {color: '#00ff40'}},
              symbolSize:2,
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+params.value[1];
                },
              },
            },
            {
              type: 'line',
              name:this.$t('auto suspend'),
              data:this.basal_suspend[i],
              itemStyle: {normal: {color: '#ff0000'}},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+params.value[2];
                },
              },
              lineStyle:{normal:{type:'dashed'}},
              symbolSize:1,
            },
            {
              type: 'line',
              name:this.$t('tempBasal'),
              data:this.tempBasal[i],
              itemStyle: {normal: {color:  '#00ff40'}},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+'TempBasal: '+params.value[1];
                },
              },
              lineStyle:{normal:{type:'dashed'}},
              symbolSize:1,
            },
            {
              type: 'line',
              name:this.$t('manualStop'),
              data:this.manualStop[i],
              itemStyle: {normal: {color: '#ff0000'}},
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', '+'Manual Suspend';
                },
              },
              symbolSize:1,
            },
            {
              type: 'bar',
              name:this.$t('normalBolus'),
              data:this.bolus[i],
              yAxisIndex:1,
              itemStyle: {normal: {color: '#182f82'}},
              barWidth:'4',
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return time[0]+':'+time[1]+', '+params.value[2]+': '+params.value[1]+ins_unit2;
                },
              },
            },
            {
              type: 'custom',
              name:this.$t('extendBolus'),
              data:this.extend_bolus[i],
              yAxisIndex:1,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return time[0]+':'+time[1]+', '+params.value[4]+': '+params.value[2]+ins_unit2+'/'+params.value[3]+'min';
                },
              },
              itemStyle:{normal: {color: '#f9b4ff'},emphasis:{color: '#f9b4ff'}},
            },
            {
              type: 'scatter',
              name:this.$t('newPatch'),
              data:this.NewBasal[i],
              symbol:'image://static/legend/new%20Patch.png',
              symbolSize:10,
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+',New Patch ';
                },
              },
            },
            {
              type: 'scatter',
              name:this.$t('stop'),
              data:this.stopBasal[i],
              symbol:'image://static/legend/patch%20Deactivated.png',
              symbolSize:8,
              tooltip:{backgroundColor:'#333',
                formatter:function(params){
                  let date = params.value[0];
                  let time = format.formatterDate5(date);
                  return  time[0]+':'+time[1]+', Delivery Stop';
                },
              },
            },
            {
              type: 'custom',
              name:this.$t('t1222_autoModeBasal'),
              data:this.autoModeBasal[i],
              yAxisIndex:0,
              renderItem:function (params,api) {
                let y = api.value(2);
                let start = api.coord([api.value(0),y]);
                let size = api.size([api.value(1)-api.value(0),y]);
                let style = api.style();
                return {
                  type:'rect',
                  shape:{
                    x: start[0],
                    y: start[1],
                    width:size[0],
                    height:size[1],
                  },
                  style:style,
                }
              },
              // tooltip:{backgroundColor:'#333',
              //   formatter:function(params){
              //     // let date = params.value[0];
              //     // let time = format.formatterDate5(date);
              //     // //return time[0]+':'+time[1]+', '+params.value[4]+': '+params.value[2]+ins_unit2+'/'+params.value[3]+'min';
              //     // //return '0.23'
              //
              //     let date = params.value[0];
              //     let time = format.formatterDate5(date);
              //     return  time[0]+':'+time[1]+', '+'TempBasal: '+params.value[1];
              //   },
              // },
              itemStyle:{normal: {color: '#00ff4c'},emphasis:{color: '#00ff5c'}},
            },

            {
              type: 'custom',
              name:this.$t('t1222_autoModeCorrBolus'),
              data:this.autoModeCorrBolus[i],
              yAxisIndex:1,
              itemStyle: {normal: {color: '#009bff'}},
              renderItem: function (params, api) {
              console.log('value: ', api.value);
              let y = api.value(2) + api.value(1);
              let start = api.coord([api.value(0), y]);
              let size = api.size([600000, y]);
              let style = api.style();
              return {
                type: 'rect',
                shape: {
                  x: start[0],
                  y: start[1],
                  width: size[0],
                  height: size[1],
                },
                style: style,
              }
            },
              barWidth:'4',
            },

          ]
        });
      },
      drawCharts2(){
        let that =this;
        this.date.map(function (e,i) {
          let id1 ='sgChart'+i;
          let id2 ='baChart'+i;
          that.drawSgChart(id1,i);
          that.drawBasalChart(id2,i);
        });
        let timer = setTimeout(this.makeCarb,1000)
      },
      chartsDispose2(){
        let dayNum = parseInt(sessionStorage.getItem('dayNum'));
        for(let i=0;i<dayNum;i++){
          let id1 ='sgChart'+i;
          let id2 ='baChart'+i;
          this[id1].dispose();
          this[id2].dispose();
          this[id1] = null;
          this[id2] = null;
        }
        sessionStorage.setItem('dayNum',this.dayNum);
      },
      //确定carb的位置
      makeCarb(){
        let carbs = this.carb;
        let time = this.timeSection;
        //console.log('carbs:', carbs)
        for(let i=0;i<carbs.length;i++){
          if(carbs[i].length>0){
            for(let j =0;j<carbs[i].length;j++){
              let t1 = 0;
              let w =0;
              t1 =carbs[i][j][0]-time[i][0];
              w = (t1/864).toFixed(1)+'%';
              //w='1%';
              let id = 'carb'+i;
              const OBJ = document.getElementById(id);
              const label= OBJ.getElementsByTagName('label');
              label[j].style.zIndex = 100+i+j;
              label[j].style.left = w;
            }
          }
        }

        // 自动模式早餐
        let className=['breakfast', 'lunch', 'dinner', 'snack'];
        let autoMeal=[this.autoBreakfast, this.autoLunch, this.autoDinner, this.autoSnack];

        for(let i=0; i<className.length; i++) {

          for (let d=0; d<autoMeal[i].length; d++) {
            for (let j=0; j<autoMeal[i][d].length; j++) {
              let t1 = 0;
              let w =0;
              t1 =autoMeal[i][d][j][0]-time[d][0];
              w = (t1/864).toFixed(1)+'%';
              let id = 'carb'+d;
              const OBJ = document.getElementById(id);
              const label= OBJ.getElementsByClassName(className[i])
              console.log('autoMeal:', OBJ, label, className[i])
              label[j].style.zIndex = 100+d+j;
              label[j].style.left = w;
            }
          }
        }

      },
      open(){
        this.staTime=format.formatterDate4(this.st);
        this.typeChooseVisible=true;
        //this.timeType =(this.dayNum === 7)?this.$t('7 days'):this.$t('14 days');
        this.timeType =(this.dayNum === 7)?1:2;
        this.Select =(this.dayNum === 7)?true:false;
      },
      cancel(){
        this.typeChooseVisible=false;
      },
      dateApply(){
        if(!this.value3){
          let t = this.endTime.split('-');
          this.et = new Date(parseInt(t[2]),parseInt(t[1])-1,parseInt(t[0])).getTime()/1000;
        }else{
          this.et = this.value3.getTime()/1000;
        }

        //let duration= document.getElementById('duration').value;
        //this.dayNum = (duration===this.$t('7 days'))?7:14;
        this.dayNum=(this.timeType==1)?7:14;
        this.st = this.et - 86400*(this.dayNum-1);
        sessionStorage.setItem('st2',this.st);
        sessionStorage.setItem('et2',this.et);
        this.ts = auth.getTs(this.st,this.et);
        this.typeChooseVisible=false;
        this.getDate();
        this.$emit('reload')
        // window.location.reload();
      },
      procTimeRangeSelect(e){
        let daySpan=7;
        if (1==this.timeType) {
          daySpan=7;
        } else if (2==this.timeType) {
          daySpan=14;
        }
        // 更新起始时间
        let et=this.value3.getTime()/1000;   // 控件上截止的时间。

        console.log('daySpan:', daySpan);
        //this.dayNum=daySpan;
        if (daySpan) {
          let st=et-86400*(daySpan-1);
          this.staTime=format.formatterDate4(st);
          //this.value4=new Date(st*1000);
        }
      },
      getDate(){
        this.date = [];
        for(let i=0;i<this.dayNum;i++){
          let day = this.st+i*86400;
          // 转夏令时时的日期调整
          if (23==new Date(day*1000).getHours()) {
            day += 3600;
          }
          let time =(this.isEn)?format.formatterDate4(day):format.formatterDate3(day);
          let weeks =  format.formatterDay(this,day);
          this.date[i] =time+' '+weeks;
        }
        this.timeRange2 = format.formatterDate2(this.st)+' - '+format.formatterDate2(this.st+(this.dayNum-1)*86400);
        this.staTime = format.formatterDate4(this.st);
        this.endTime = format.formatterDate4(this.et);
        //
        this.value3=new Date(this.et*1000);
      },
      print(){
        let src2_1 = [],src2_2 =[];
        let dayNum = parseInt(sessionStorage.getItem('dayNum'));
        for(let i=0;i<dayNum;i++){
          let id1 ='sgChart'+i;
          let id2 ='baChart'+i;
          let src1 = this[id1].getDataURL();
          src2_1.push(src1);
          let src2 = this[id2].getDataURL();
          src2_2.push(src2);
        }
        sessionStorage.setItem('src2_1',JSON.stringify(src2_1));
        sessionStorage.setItem('src2_2',JSON.stringify(src2_2));
        sessionStorage.setItem('date2_2',JSON.stringify(this.date));
        sessionStorage.setItem('carb2_2',JSON.stringify(this.carb));
        sessionStorage.setItem('autoBreakfast2_2',JSON.stringify(this.autoBreakfast));
        sessionStorage.setItem('autoLunch2_2',JSON.stringify(this.autoLunch));
        sessionStorage.setItem('autoDinner2_2',JSON.stringify(this.autoDinner));
        sessionStorage.setItem('autoSnack2_2',JSON.stringify(this.autoSnack));
        sessionStorage.setItem('timeS2_2',JSON.stringify(this.timeSection));
        sessionStorage.setItem('dd_pump_device', this.pump_device);
        window.open('/#/chart2-print','_blank');
      },
      handleResize(){
        let win = window.innerWidth;
        let scale = (win<1500)?0.91:0.62;
        const chartWidth = win*scale*0.98*0.945*0.33+'px';
        const carbWidth =  win*scale*0.98*0.945*0.37*0.865+'px';
        for(let i=0;i<this.dayNum;i++){
          let id1 ='sgChart'+i;
          let id2 ='baChart'+i;
          let id3 ='carb'+i;
          let chart1 = document.getElementById(id1);
          let chart2 = document.getElementById(id2);
          let carb = document.getElementById(id3);
          if(chart1){
            chart1.style.width = chartWidth;
            chart2.style.width = chartWidth;
            carb.style.width = carbWidth;
          }
        }
      },
    },
    beforeDestroy(){
        if(this.sgChart1){
          this.chartsDispose2();
        }
        this.sg=[];
        this.basal =[];
    },
    mounted: function () {

      let win = window.innerWidth;
      this.dialogSize =(win<1500)?'small':'tiny';
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.titleText = (this.isMg)?this.$t('SG')+' (mg/dL)':this.$t('SG')+' (mmol/L)';
      this.sgMax = (this.isMg)? 400:25;

      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      //
      if(!sessionStorage.getItem('st2')){
        var nd=new Date();
        var cur_day=new Date(nd.getFullYear(), nd.getMonth(), nd.getDate()-1)
        //this.et= new Date().setHours(0,0,0,0)/1000-86400;
        this.et=cur_day/1000;
        var chart_end_time=sessionStorage.getItem('chart_end_time');
        for (var d=0; d<3000; d++) {
          if (this.et > chart_end_time) {
            //this.et -= 24*3600;
            cur_day=new Date(cur_day.getFullYear(), cur_day.getMonth(), cur_day.getDate()-1)
            //et -= 24*3600;
            this.et=cur_day/1000;
          } else {
            //this.et += 24*8600;
            break;
          }
        }
        this.st = this.et-86400*6;
        //console.log('dd.st.1:'+this.st+','+this.et+','+chart_end_time);
      }else{
        console.log('st2 init.2:');
        this.st = parseInt(sessionStorage.getItem('st2'));
        this.et = parseInt(sessionStorage.getItem('et2'));
        //console.log('dd.st.2:'+this.st+','+this.et);
      }
      sessionStorage.setItem('st2',this.st);
      sessionStorage.setItem('et2',this.et);
      this.dayNum = (this.et-this.st)/86400+1;
      sessionStorage.setItem('dayNum',this.dayNum);
      this.getDate();
      this.ts = auth.getTs(this.st,this.et);
      //console.log("this.ts: ", this.ts);
      // 转夏令时时的日期调整
      for (let i=0; i<this.ts.length; i++) {
        if (23==new Date(this.ts[i][0]*1000).getHours()) {
          this.ts[i][0] += 3600;
        }
        if (23==new Date(this.ts[i][1]*1000).getHours()) {
          this.ts[i][1] += 3600;
        }

        // console.log("ts item:", new Date(this.ts[i][0]*1000), new Date(this.ts[i][1]*1000));
        // console.log("ts item.2:", new Date(this.ts[i][0]*1000).getHours(), new Date(this.ts[i][1]*1000).getHours());

      }
      let param = {
        ts:this.ts,
        tz:parseInt(sessionStorage.getItem('tz')),
      };
      param = B64.base64encode(JSON.stringify(param));
      //console.log({param});
      auth.getDd(this,this.uid,param);
      let that = this;
      /*auth.getDataMap(this, this.uid, function(res) {
        //console.log(res);
        if (0!=res.error) {
          return;
        }
        var end_time=(res.end.cgms > res.end.pump)?res.end.cgms:res.end.pump;
        //console.log(param)
        var ts_size=param.ts.length;
        var time_offset=0;
        var cur_end=param.ts[ts_size-1][1];
        //console.log(cur_end + ', '+end_time);
        for (var d=0; d<3000;d++) {
          if(cur_end>end_time) {
            cur_end -= 24*3600;
          } else {
            break;
          }
        }
        //console.log(d)
        if (d)
          d -= 1;
        for (var i=0; i<ts_size; i++) {
          param.ts[i][0] -= 24*3600*d;
          param.ts[i][1] -= 24*3600*d;
        }
        console.log(param)
        that.st=param.ts[0][0];
        that.et=param.ts[ts_size-1][0];
        that.timeRange2 = format.formatterDate2(that.st)+' - '+format.formatterDate2(that.st+(that.dayNum-1)*86400);
        that.getDate();
        param = B64.base64encode(JSON.stringify(param));
        auth.getDd(that, that.uid, param);
      });*/

      window.onresize = function () {
        that.handleResize();
        if(that.sgChart0){
          for(let i=0;i<that.dayNum;i++){
            let id1 ='sgChart'+i;
            let id2 ='baChart'+i;
            that[id1].resize();
            that[id2].resize();
          }
        }
      }
    }
  }
</script>

<style scoped>
  .chart-container {
    width: 100%;
    min-height:1050px;
    float: left;
    font-family:SFUIText-Regular;
    font-size:14px;
    color:#282828;
    letter-spacing:-0.34px;
  }
  .chart-container-spe1{
    height:1700px;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    margin-top:10px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }

  .main-header-right{
    float: right;
    width:80%;
    height:30px;
    line-height: 30px;
    margin-right: 1%;
  }
  .main-header-right p{
    float: right;
    margin-right:15px;
    margin-top:2px;
  }
  .main-header-right .time{
    font-size:16px;
    letter-spacing:-0.39px;
    color:#0082d2;
    margin-left: 10px;
  }
  .main-header-right button{
    float: right;
    border-radius:100px;
    box-shadow:0 3px 4px 0 #e8f3ff;
    background: #fff;
    border: 1px solid #a3a3a3;
    width:110px;
    height:26px;
    line-height: 26px;
    outline: none;
    margin-top:4px;
    margin-left: 3%;
    cursor: pointer;
  }
  button:hover{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    color:#fff;
  }
  button span{
    font-family:SFUIText-Regular;
    font-size: 16px;
    letter-spacing:-0.39px;
  }
  .main-header-right .set{
    margin-left: 0;
  }
  .el-date-editor.el-input{
    width:125px;
  }

  /*选择日期范围时样式*/
  .time-range{
    *width:551px;
  }
  .time-range p{
    margin: 0 18px 18px;
    margin-top: 2px;
  }
  .blockgroup{
    float: left;
  }
  .block1{
    float: left;
  }
  .block2{
    float: left;
  }
  .time-range button{
    float: right;
    margin-right: 2.2%;
  }

  .small-hr{
    background:#e6e8ea;
    width:97%;
    height:1px;
    margin:10px auto 20px;
    border:none;
  }
  .spe-hr{
    margin-bottom:20px ;
  }

  .chart-item2 {
    width: 33%;
    float: left;
  }
  .chart-container .graph{
    width:100%;
    height:160px;
    margin-top:-15px;
  }
  .date{
    width:33%;
    float:left;
    font-size:16px;
    color:#0082d2;
    letter-spacing:-0.39px;
    line-height:13px;
    text-align:center;
  }
  .date-spe3{
    width:80%;
    margin-left: 9%;
  }
  .eat-label{
    font-size:12px;
    color:#282828;
    letter-spacing:-0.29px;
    width:33%;
    margin:8px 0 -2px 0;
    text-align:center;
    float: left;
  }
  .eat-spe3{
    display: flex;
    width:100%;
    margin-left: 6%;
  }
  .eat-spe3-po{
    display: flex;
    width: 100%;
    margin-left: 3%;
  }
  .eat-spe3 span{
    display: flex;
  }
  .eat-label-spe1{
    flex: 0 0 26%
  }
  .eat-label-spe1-po{
    flex: 0 0 21%
  }
  .eat-label-spe1-fo{
    flex: 0 0 21%;
    margin-top: -20px;
  }
  .eat-label-spe2{
    flex: 0 0 8%
  }
  .eat-label-spe2-po{
    flex: 0 0 24%
  }
  .eat-label-spe3{
    flex: 0 0 26%
  }
  .eat-label-spe3-po{
    flex: 0 0 12%
  }
  .eat-label-spe3-fo{
    flex: 0 0 12%;
    margin-top: -6px;
  }
  .eat-label-spe4{
    flex: 0 0 18%
  }
  .eat-label-spe4-po{
    flex: 0 0 28%
  }
  .eat-label-spe3-en{
    flex: 0 0 19%
  }
  .eat-label-spe4-en{
    flex: 0 0 23%
  }
  .carb{
    width:96.4%;
    margin:2px 0 14px 3%;
    height:20px;
    line-height: 20px;
    padding-left: 5px;
    border: 1px solid #ccc;
    position: relative;
    font-size:12px;
  }
  .carb span{
    float: left;
  }
  .carb label{
    display: inline-block;
    border:1px solid #00ff4c;
    border-radius:4px;
    width:27px;
    height:15px;
    line-height: 15px;
    float: left;
    position: absolute;
    font-size:13px;
    color:#000;
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 2px;
    background-color: #00ff4c;
    font-family:SFUIText-Regular;
  }

  .carb img {
    float: left;
    position: absolute;
    display: inline-block;
  }

  .carb-spe2{
    width:85.2%;
    margin:-56px 0 14px 8%;
  }

  .legend-group{
    width:96%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .legend{
    float:left;
    margin-bottom: 8px;
    margin-right:60px;
    height:20px;
    line-height: 20px;
  }
  .zh5 .legend{
    margin-right:70px;
  }
  .legend img{
    margin-right: 8px;
  }
  .legend-spe1{
    margin-right: 38px;
  }
  .legend-spe2{
    *margin-bottom: 13px;
  }
  .legend-spe3{
    margin-right: 18px;
  }
  .legend-spe4{
    margin-right: 53px;
  }
  .legend-spe5{
    margin-right: 15px;
  }
  .legend-spe6{
    margin-right: 30px;
  }
  .legend-spe7{
    margin-right: 83px;
  }
  .legend-group .span1{
    margin-bottom: 2px;
    display: block;
    float: right ;
  }
  .img-spe{
    margin-bottom: 4px;
  }
  .zh5 .zh6{
    margin-right: 45px;
  }
  .zh5 .zh7{
     margin-right: 60px;
   }
  .zh5 .zh8{
    margin-right: 33px;
  }
  .zh5 .zh9{
    margin-right: 48px;
  }
  .zh5 .zh10{
    margin-right: 30px;
  }
  .zh5 .zh11{
    margin-right: 56px;
  }
  .zh5 .zh12{
    margin-right: 56px;
  }
  .zh5 .zh13{
    margin-right: 114px;
  }
  .zh5 .zh14{
    margin-right: 88px;
  }

  .it5 .legend{
    margin-right:40px;
  }

  .po5 .legend{
    margin-right:40px;
  }
  .du5 .legend{
    margin-right:40px;
  }

  /*对话框*/
  #dialog-form2{
    font-family:SFUIText-Regular;
  }
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
  .dialog-body{
    width:100%;
    margin-top: 25px;
  }
  .patientList-small-hr{
    background:#dedede;
    width:94%;
    height:1px;
    margin:20px 0 10px 10px;
    border:none;
    clear: both;
  }
  .duration{
    margin-left: 20px;
    height:35px;
    line-height: 35px;
    margin-bottom: 20px;
  }
  .duration span{
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-left: 18px;
    margin-right: 15px;
  }
  .duration select{
    height: 28px;
    width: 100px;
    border-radius: 4px;
    padding-left: 10px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.44px;
  }
  .dialog-body .time-range{
    margin-left: 22px;
    height:35px;
    line-height: 35px;
    margin-bottom: 35px;
  }
  .time-range p{
    float: left;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    letter-spacing:-0.44px;
    text-align:center;
    margin-right: 25px;
  }
  .time-range .block{
    float: left;
  }
  .time-range .date{
    float: left;
    width:22%;
    height:40px;
    line-height: 40px;
    color:#282828;
    font-size: 16px;
    margin-right: 13%;
  }
  .el-date-editor.el-input{
    width:125px;
  }

  .dialog-footer{
    margin:-25px auto 15px;
    width:70%;
  }
  .dialog-footer button{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:40%;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }
  .dialog-footer .cancelButton{
    background: transparent;
    border:1px solid #009fdf;
    color: #282828;
    outline: none;
    margin-left: 7%;
  }

  @media screen and (max-width: 1300px){
    .legend{
      margin-right:48px;
    }
    .it5 .legend{
      margin-right:30px;
    }
    .po5 .legend{
      margin-right:30px;
    }
    .du5 .legend{
      margin-right:30px;
    }
  }
</style>



// WEBPACK FOOTER //
// chart2-2.vue?1f71ead7